module.exports = __webpack_public_path__ + "static/media/hjerte.70a95575.mp3";